<template>
    <ai-form-text-box-dictionary
        ref="tbdRef"
        display-expr="name_bank"
        value-expr="kodb"
        field-name-id="kodbpol"
        field-name-text="bank_pol"
        title="Банк получателя"
        :validationRules="validationRules"
        :data-source="dict"
        :callbacks="{ ...callbacks, dotsClick }"
        :key="componentKey"
        @popupShown="popupShown"
        @popupShowing="popupShowing"
    >
        <ai-dictionary-virtual-grid v-if="renderComponent"
                                    ref="dvgRef"
                                    :meta="extParams"
                                    :current-value="userData[meta.fieldNameText]"
                                    @dictionarySelectionChanged="selectionChanged"
        />
    </ai-form-text-box-dictionary>
</template>
<script setup>
import AiFormTextBoxDictionary from '@/components/card-component/ai-form-text-box-dictionary.vue';
import {computed, inject, ref, nextTick, onBeforeMount} from 'vue';
import AiDictionaryVirtualGrid from '@/components/dictionary-components/ai-dictionary-virtual-grid.vue';

const props = defineProps({
    meta: {
        type: Object,
        default: () => {
        },
    },
    callbacks: {
        type: Object,
        default: () => ({
            userDataChanged: null,
            dotsClick: () => {
                console.log('component-receiver-bank, dotsClick');
            },
        }),
    },
});

const dotsClick = () => {
    props.callbacks.dotsClick(props.meta);
};
const userData = inject('userData');
const validationResult = inject('validationResult');
const tbdRef = ref(null);
const dvgRef = ref(null);
const renderComponent = ref(false);
const componentKey = ref(0);
const validationRules = ref({required: false});
const extParams = ref(null);
const dict = computed(() => {
    return [
        {
            [`kodb`]: userData.value['kodbpol'],
            [`name_bank`]: userData.value['bank_pol'],
        },
    ];
});

onBeforeMount(() => {
    extParams.value = {
        displayExpr: 'name_bank',
        valueExpr: 'kodb',
        meta_args: {
            key: 'kodbpol',
            db_schema_name: 'dog',
            db_view_name: 'kv_bankpol',
        },
        columns: [
            {field: 'kodbpol', text: 'kodp', visible: false},
            {field: 'npp', text: '№ п/п', width: 20},
            {field: 'ocher_plat', text: 'Очерёдность платежа', width: 100},
            {field: 'rs', text: 'Расчётный счёт', width: 100},
            {field: 'name_bank', text: 'Наименование банка', width: 200},
            {field: 'filial', text: 'Наименование филиала', width: 200},
            {field: 'bic', text: 'БИК', width: 50},
            {field: 'ks', text: 'Кор. счёт', width: 100},
            {field: 'adr', text: 'Адрес', width: 200},
            {field: 'p_ind', text: 'Индекс', width: 50},
            {field: 'name_dep', text: 'Отделение', width: 200},
            {field: 'predel', text: 'Минимальная сумма платёжного док-та (руб.)', width: 50},
            {field: 'pr_active', text: 'Удалён', width: 50},
            {field: 'copys', text: 'Кол-во копий при печати к реестру', width: 100},
            {field: 'dat_otkr', text: 'Дата открытия', width: 100},
            {field: 'dat_fin', text: 'Дата закрытия', width: 100},
            {field: 'remark', text: 'Примечание', width: 200},
            {field: 'days_accept', text: 'Кол-во дней для акцепта', width: 200},
            {field: 'service', text: 'Код услуги', width: 100},
        ],
        loadUrl: 'contract./card/data/get',
        keyExpr: 'kodbpol',
        autoLoadData: false,
        toRemoveToolbarItemsNames: ['copy', 'edit', 'add', 'delete', 'save'],
    };
})



const popupShown = () => {
    dvgRef.value?.gridInstance.loadData();
};

const popupShowing = () => {
    if (!renderComponent.value) {
        tbdRef.value.changePopupVisibility(false);
        renderComponent.value = true;
        componentKey.value += 1;
        nextTick().then(()=>{tbdRef.value.changePopupVisibility(true);})
    }
};


const userDataChange = value => {
    validationResult.value = validationResult.value.filter(s => s.fieldNameText !== props.meta.fieldNameText);
    userData.value['bank_pol'] = value['name_bank']; // менять ключ и значение
    userData.value['kodbpol'] = value['kodb'];
    //Если нужно помимо основных ключей обновлять еще какието поля в карточке
    props.meta.extParams.additionalFiels?.forEach(item => {
        userData.value[item.cardFieldName] = value[item.dictFieldName];
    });
    props.callbacks.userDataChanged(value);
};
const selectionChanged = async event => {
    userDataChange(event);
    tbdRef.value?.popupInstance.hide();
};
</script>
